module.exports = __webpack_public_path__ + "img/sysLogs.1c6d2ee2.svg";